import { useEffect, useState } from "react";
import FileUploader from "devextreme-react/file-uploader";
import { baseUrl, getAuthHeader, post } from "../modules/server";
import { logAndNotifyError } from "../modules/logger";
import Notify from "devextreme/ui/notify";
import { UploadedEvent, UploadErrorEvent } from "devextreme/ui/file_uploader";
import { useParams, useSearchParams } from "react-router-dom";
import notify from "devextreme/ui/notify";
import { useForm } from "react-hook-form";
import ValidationSummaryMessages from "../components/Configuration/ValidationSummaryMessages";
import TextEditor from "../components/Global/Editors/TextEditor";
import { Card } from "react-bootstrap";

const WelcomeNewUser = () => {
  const [userInfo, setUserInfo] = useState({ userId: null as null | string, code: null as null | string });

  const [pwdReset, setPwdReset] = useState<string | undefined>(undefined);
  const [pwdMessage, setPwdMessage] = useState({ success: true, error: "", hide: true as boolean });

  //const { code, userId } = useParams();
  const [searchParams] = useSearchParams();

  const formHook = useForm({
    defaultValues: {},
  });
  const {
    handleSubmit,
    formState: { errors },
  } = formHook;

  const code = searchParams.get("code");
  const userId = searchParams.get("userId");

  if (userInfo.code !== code || userInfo.userId !== userId) {
    setUserInfo({ userId, code });
    setPwdReset(undefined);
    setPwdMessage({ success: true, error: "", hide: true });
    formHook.reset({});
  }

  useEffect(() => {
    const checkCode = async () => {
      if (userInfo.code && userInfo.userId) {
        setPwdReset(undefined);
        const checkResult = await post("CheckEmailConfirmation", userInfo);
        if (checkResult.success) {
          setPwdReset(checkResult.token);
        }
      }
    };
    checkCode();
  }, [userInfo]);

  const onSubmit = async (data: any) => {
    if (data.password === data.confirm) {
      const pwdResult = await post("ChangePassword", { userId: userInfo.userId, token: pwdReset, password: data.password });
      if (pwdResult.success) {
        setPwdMessage({ success: true, error: "", hide: false });
      } else {
        setPwdMessage(pwdResult);
      }
    }
  };

  const onCancel = () => {};

  if (pwdReset)
    return (
      <>
        <h2>Välkommen till QWTOOL</h2>
        {!(pwdMessage.success && !pwdMessage.hide) /* There is no success message to show - Show password boxes */ ? (
          <div>
            <div>Vänligen ange ett lösenord för att börja använda systemet</div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row overflow-hidden gy-0">
                <div className="col-12">
                  <TextEditor label="Lösenord" fieldName="password" formHook={formHook} isPassword={true} />
                </div>

                <div className="col-12">
                  <TextEditor
                    label="Bekräfta lösenord"
                    fieldName="confirm"
                    formHook={formHook}
                    isPassword={true}
                    options={{
                      validate: {
                        same: (val) => {
                          const frm: any = formHook.getValues();
                          return frm.password !== val ? "Lösenordet matchar inte" : undefined;
                        },
                      },
                    }}
                  />
                </div>
              </div>
              <div className="d-grid gap-2 d-md-flex justify-content-md-end mt-3">
                <div style={{ paddingRight: 12, paddingLeft: 4 }}>
                  <button type="button" className="btn btn-secondary ms-2" onClick={onCancel}>
                    Avbryt
                  </button>
                  <button type="submit" className="btn btn-primary ms-2">
                    Bekräfta nytt lösenord
                  </button>
                </div>
              </div>
            </form>
          </div>
        ) : (
          <></>
        )}

        {!pwdMessage.hide /* There is a message to show - Show it */ ? (
          <div style={{ padding: 20 }}>
            {pwdMessage.success ? (
              <Card>
                <Card.Header style={{ color: "black" }}>Lösenordet har ändrats!</Card.Header>
                <Card.Body>Du kan nu logga in i applikationen genom att klicka på 'Logga in'</Card.Body>
              </Card>
            ) : (
              <Card>
                <Card.Header style={{ color: "red" }}>Lösenordet kunde inte ändras!</Card.Header>
                <Card.Body>
                  <div style={{ whiteSpace: "pre", wordWrap: "initial", wordBreak: "initial" }}>{pwdMessage.error}</div>
                </Card.Body>
              </Card>
            )}
          </div>
        ) : (
          <></>
        )}
      </>
    );
  else
    return (
      <>
        <h2>Välkommen till QWTOOL</h2>
        <div>Antingen är koden för gammal eller så har du redan angivit ett lösenord.</div>
        <div>Om du har ditt lösenord, klicka på "Logga in" i övre högra hörnet.</div>
        <div>Om du INTE har ditt lösenord, var vänlig att kontakta system-administratören för att få ett.</div>
      </>
    );
};

export default WelcomeNewUser;
